import React, { memo } from "react";
import * as R from "ramda";

import { regions, countryHasStates, toStateOptions, toStateName } from "utils/regions";
import SearchableSelectField from "../SearchableSelect";
import TextField from "../Text";

function StateSelectField({ name = "state", country, ...rest }) {
  const selectedCountry = R.find(R.propEq("ISO", country))(regions);
  const selectedCountryHasStates = countryHasStates(country);

  if (selectedCountryHasStates) {
    return (
      <SearchableSelectField
        label="State"
        name={name}
        options={toStateOptions(selectedCountry.States)}
        valueModifier={(v) => toStateName(country, v)}
        {...rest}
      />
    );
  }

  return <TextField label="State / Region" name={name} />;
}

export default memo(StateSelectField);
